/* eslint-disable */
import React from 'react';
import { Modal } from 'react-bootstrap';
import "../../styles/time_table_management.css";
import applicationstagesLabels from '../labels/applicationstages_en.json'

const ObjectionAnswerKeyDataModal = (props) => {
    const cancelModal = () => {
        props.setShowObjectionAnswerKeyModal(false);
        props.setObjectionAnswerKeyModalData("");
    }

    return (
        <div>
            <Modal size="xl" show={props.showObjectionAnswerKeyModal} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static'>
                <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title></Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div>
                            {props && props.objectionAnswerKeyModalData && props.objectionAnswerKeyModalData.advertisementExamsetQuestionsList && props.objectionAnswerKeyModalData.advertisementExamsetQuestionsList.length > 0 ?
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            {applicationstagesLabels.ObjectionAnswerKeyDataHeaderContent.map((ele, index) =>
                                                <th scope="col" key={index} className='text-center theadBgColor'>{ele}</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props && props.objectionAnswerKeyModalData && props.objectionAnswerKeyModalData.advertisementExamsetQuestionsList && props.objectionAnswerKeyModalData.advertisementExamsetQuestionsList.map((ele, i) => {
                                            if (ele) {
                                                return (
                                                    <tr>
                                                        <td className="word-break text-center fw-bold custom-width">{ele.setA ? ele.setA : ""}</td>
                                                        <td className="word-break text-center fw-bold custom-width">{ele.setB ? ele.setB : ""}</td>
                                                        <td className="word-break text-center fw-bold custom-width">{ele.setC ? ele.setC : ""}</td>
                                                        <td className="word-break text-center fw-bold custom-width">{ele.setD ? ele.setD : ""}</td>
                                                        <td className="word-break text-center fw-bold custom-width">{ele.answer ? ele.answer : ""}</td>
                                                    </tr>
                                                )
                                            }
                                        })}

                                    </tbody>
                                </table>
                                : ""
                            }
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal}>{applicationstagesLabels.CANCEL}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ObjectionAnswerKeyDataModal;